import { render, staticRenderFns } from "./BellDelete.vue?vue&type=template&id=16e7bd35&scoped=true"
import script from "./BellDelete.vue?vue&type=script&lang=js"
export * from "./BellDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e7bd35",
  null
  
)

export default component.exports